import { render, staticRenderFns } from "./productSkuMapping.vue?vue&type=template&id=fdfdff0c&"
import script from "./productSkuMapping.vue?vue&type=script&lang=js&"
export * from "./productSkuMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports